// Friends page — request, accept, challenge, remove. Lifted out of the
// lobby so the lobby can focus on the play-loop.
import { ApiError, api } from '../api/client';
import { handleVerifyEmailError } from './lobby';
let unmounted = false;
export function unmountFriends() { unmounted = true; }
export async function renderFriends(root, goToLobby, _goToMatch) {
    void _goToMatch;
    unmounted = false;
    let data = { friends: [], incoming: [], outgoing: [] };
    async function refresh() {
        try {
            data = await api.listFriends();
        }
        catch { /* swallow */ }
        render();
    }
    function render() {
        if (unmounted)
            return;
        root.innerHTML = `
      <div class="page friends-page">
        <header class="page-header">
          <button class="btn btn--ghost btn--icon" id="btn-back-lobby" title="Back to lobby">←</button>
          <h1 class="page-title">Friends</h1>
        </header>
        ${data.incoming.length > 0 ? `
          <section class="friends-section">
            <h2>Incoming requests</h2>
            ${data.incoming.map((req) => `
              <div class="friend-row friend-row--incoming">
                <span class="friend-name">${escape(req.name)}</span>
                <div class="friend-actions">
                  <button class="btn btn--small" data-friend-accept="${req.id}">Accept</button>
                  <button class="btn btn--small btn--ghost" data-friend-deny="${req.id}">Deny</button>
                </div>
              </div>
            `).join('')}
          </section>` : ''}

        <section class="friends-section">
          <h2>Crew (${data.friends.length})</h2>
          ${data.friends.length === 0
            ? '<div class="empty">No friends yet. Send a request below.</div>'
            : data.friends.map((f) => `
              <div class="friend-row">
                <span class="friend-name">${escape(f.name)}</span>
                <div class="friend-actions">
                  <button class="btn btn--small" data-friend-challenge="${f.user_id}" title="Send a challenge — they must accept before the match starts">⚔ Challenge</button>
                  <button class="btn btn--small btn--ghost" data-friend-remove="${f.user_id}" title="Remove friend">✕</button>
                </div>
              </div>`).join('')}
        </section>

        <section class="friends-section">
          <h2>Add a friend</h2>
          <form id="form-friend-add" class="friend-add-form">
            <input id="friend-add-input" name="name" placeholder="Captain display name" maxlength="32" autocomplete="off" />
            <button type="submit" class="btn">+ Send request</button>
          </form>
          ${data.outgoing.length > 0
            ? `<div class="friends-pending">Pending: ${data.outgoing.map((r) => escape(r.name)).join(', ')}</div>`
            : ''}
        </section>
      </div>
    `;
        root.querySelector('#btn-back-lobby')?.addEventListener('click', goToLobby);
        root.querySelector('#form-friend-add')?.addEventListener('submit', async (e) => {
            e.preventDefault();
            const input = root.querySelector('#friend-add-input');
            const name = input.value.trim();
            if (!name)
                return;
            try {
                await api.requestFriend(name);
                input.value = '';
                await refresh();
            }
            catch (err) {
                if (await handleVerifyEmailError(err))
                    return;
                alert((err instanceof ApiError ? err.message : err.message));
            }
        });
        root.querySelectorAll('[data-friend-accept]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                try {
                    await api.respondFriend(parseInt(btn.dataset.friendAccept, 10), true);
                    await refresh();
                }
                catch (err) {
                    alert(err.message);
                }
            });
        });
        root.querySelectorAll('[data-friend-deny]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                try {
                    await api.respondFriend(parseInt(btn.dataset.friendDeny, 10), false);
                    await refresh();
                }
                catch (err) {
                    alert(err.message);
                }
            });
        });
        root.querySelectorAll('[data-friend-challenge]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                try {
                    await api.challengeFriend(parseInt(btn.dataset.friendChallenge, 10));
                    alert("Challenge sent. They'll see it in their lobby and can accept (or swap their ship first) before the match starts.");
                    goToLobby();
                }
                catch (err) {
                    if (await handleVerifyEmailError(err))
                        return;
                    alert(err.message);
                }
            });
        });
        root.querySelectorAll('[data-friend-remove]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                if (!confirm('Remove this friend?'))
                    return;
                try {
                    await api.removeFriend(parseInt(btn.dataset.friendRemove, 10));
                    await refresh();
                }
                catch (err) {
                    alert(err.message);
                }
            });
        });
    }
    render();
    refresh();
}
function escape(s) {
    return s.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
